<template>
  <div>
    <v-navigation-drawer app location="left" v-model="drawer" width="250" height="100%"
      class="k-app-sidebar z-index-900" v-if="user && activeWorkspace">
      <div class="pa-2">
        <a href="/">
          <v-img :src="kyano.logo" height="30" width="100"></v-img>
        </a>
      </div>
      <div class="k-app-sidebar-body">
        <v-list class="menu-small" density="compact" nav :lines="false"
          :color="`${activeWorkspace?.color || '#24a1c7'}`">
          <v-list-item v-for="(item, index) in getMenuItems()" :key="index" :to="item.to">
            <template v-slot:prepend>
              <div class="menu-icon-left">
                <i :class="`fal ${item.icon}`"></i>
              </div>
            </template>
            <template v-slot:append>
              <v-chip v-if="item.append" variant="flat" size="small" color="var(--danger)">{{
        item.append
      }}</v-chip>
            </template>

            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item>
        </v-list>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useMainStore } from "@/stores/store"; // Adjust this path to your store location
import WorkspaceService from "@/services/WorkspaceServices";
import api from "../../services/api";

export default {
  data() {
    return {
      drawer: true,
      selectedmenuitems: [],
      workspaces_list: [],
      expand: true,
    };
  },

  computed: {
    ...mapState(useMainStore, ["user", "workspaces", "kyano"]),

    workspace_id() {
      return this.user.active_workspace_id;
    },

    activeWorkspace() {
      if (!Array.isArray(this.workspaces_list)) {
        return {};
      }

      return this.user.active_workspace || {};
    },

    activeWorkspaceslist() {
      return this.workspaces_list.filter((workspace) => workspace.status === "active");
    },
  },
  methods: {
    getMenuItems() {
      return [
        { title: "Dashboard", to: `/admin`, icon: "fa-home-alt" },
        { title: "Inbox", to: `/admin/inbox`, icon: "fa-envelope" },
        { title: "Gebruikers & debiteuren", to: `/admin/users`, icon: "fa-users" },
        { title: "Deals", to: `/admin/sales`, icon: "fa-tasks" },
        { title: "Projecten", to: `/admin/projects`, icon: "fa-project-diagram" },
        { title: "Documenten", to: `/admin/docs`, icon: "fa-file-alt" },
        { title: "Financieel", to: `/admin/finance`, icon: "fa-chart-line" },
        { title: "Instellingen", to: `/admin/settings`, icon: "fa-cog" },
      ];
    },

    async fetchWorkspaces() {
      try {
        const response = await WorkspaceService.getWorkspaces();
        if (response.data && Array.isArray(response.data.workspaces)) {
          this.workspaces_list = response.data.workspaces;
        } else {
          this.workspaces_list = []; // Stel een lege array in als de data geen werkruimten bevat
        }
      } catch (error) {
        console.error("Error fetching workspaces:", error);
        this.workspaces_list = []; // Fallback naar lege array
      }
    },

    waitForWorkspaceId() {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          if (this.user.active_workspace_id) {
            clearInterval(interval);
            resolve();
          }
        }, 100); // Controleer elke 100ms of workspaceId beschikbaar is
      });
    },

    selectWorkspace(workspaceId) {
      // Make the API request to update the active workspace on the backend
      api
        .post("/api/v1/users/me/active-workspace", {
          workspace_id: workspaceId,
        })
        .then((response) => {
          this.$toast.success("Workspace switched successfully.");
          console.log(response.data.message); // Optional: Log success message

          this.dialogVisible = false; // Close the dialog

          // Programmatically navigate to the dashboard of the new workspace
          window.location.href = `/${workspaceId}`;
        })
        .catch((error) => {
          console.error(
            "Error selecting workspace",
            error.response?.data || error.message
          );
          this.$toast.error(error.response?.data || error.message);
        });
    },

    updateSelectedItems(newSelectedItems) {
      this.selectedmenuitems = newSelectedItems;
    },

    getMenuItemsFooter() {
      return [
        {
          title: "Upgrade",
          to: `/${this.workspace_id}/settings/team/${this.workspace_id}/upgrade`,
          icon: "fa-rocket",
        },
        {
          title: "Members",
          to: `/${this.workspace_id}/settings/team/${this.workspace_id}/users`,
          icon: "fa-users",
        },
        {
          title: "Usage",
          to: `/${this.workspace_id}/settings/team/${this.workspace_id}/usage`,
          icon: "fa-chart-line",
        },
        {
          title: "Billing",
          to: `/${this.workspace_id}/settings/team/${this.workspace_id}/billing`,
          icon: "fa-money-check-alt",
        },
        {
          title: "My account",
          to: `/${this.workspace_id}/settings/team/${this.workspace_id}/me`,
          icon: "fa-user",
        },
        {
          title: "Settings",
          to: `/${this.workspace_id}/settings/team/${this.workspace_id}/general`,
          icon: "fa-cog",
        },
      ];
    },

    logout() {
      cookies.remove("kyano_access_token");
      cookies.remove("kyano_user");
      location.replace("/login");
    },
  },
  mounted() {
    this.fetchWorkspaces();
  },
};
</script>

<style>
.z-index-900 {
  z-index: 900 !important;
}
</style>

<!-- 
<script>
import { mapState } from "pinia";
import { useMainStore } from "@/stores/store"; // Adjust this path to your store location
import cookies from "js-cookie";

export default {
  data() {
    return {
      drawer: true,
      selectedmenuitems: [],
      workspaces: {},
      workspaces_list: [],
    };
  },

  computed: {
    ...mapState(useMainStore, ["user", "workspaces", "kyano"]),

    workspace_id() {
      return this.user.active_workspace_id;
    },


  },
  methods: {
   
  },

};
</script> -->
